<template>
    <section class="error-format">
        <div v-if="error.message">&#9888; {{ error.message }}</div>
        <div v-if="error.errors && error.errors.length > 0">
            <ul>
                <li v-for="(err, index) in error.errors" :key="index">{{ err.message }}</li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ErrorList',
    props: [ 'error' ]
}
</script>

<style scoped>
.error-format {
    background-color: #792061;
    color: #ffffff;
    padding: 6px 12px;
    font-size: 1.8rem;
    line-height: 130%;
    animation-name: error-format-fadein;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.3s;
    margin: 2rem 0;
}

@keyframes error-format-fadein {
    from {opacity: 0;}
    to {opacity: 1;}
}

@media screen and (max-width: 399px) {
    .error-format {
        font-size: 1.2rem;
    }
}

@media screen and (min-width: 400px) and (max-width: 719px) {
    .error-format {
        font-size: 1.4rem;
    }
}
</style>
